module.exports = __webpack_public_path__ + "fonts/FreightNeoProBlack-Italic.8a09e9e2.otf";